import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useStatus } from './contexts/StatusContext';
import AdminLayout from './components/AdminLayout';
import SignIn from './pages/SignIn';
import OAuthCallback from './pages/OAuthCallback';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Subscriptions from './pages/Subscriptions';
import Projects from './pages/Projects';
import Standards from './pages/Standards';
import AuditTrail from './pages/AuditTrail';
import KnowledgeCuration from './pages/KnowledgeCuration';
import Settings from './pages/Settings';
import ApiTokens from './pages/ApiTokens';
import ExecutiveReports from './pages/ExecutiveReports';
import ManagerDashboard from './pages/ManagerDashboard';
import Onboarding from './pages/Onboarding';
import EnterpriseOnboarding from './pages/EnterpriseOnboarding';
import DiscoveryReview from './pages/DiscoveryReview';
import DeveloperInsights from './pages/DeveloperInsights';
import ControlTower from './pages/ControlTower';
import CorpusManagement from './pages/CorpusManagement';
import DocumentManagement from './pages/DocumentManagement';
import CorrectionQueue from './pages/CorrectionQueue';
import CurationQueue from './pages/CurationQueue';
import ClaimsReview from './pages/ClaimsReview';
import CaptureReview from './pages/CaptureReview';
import Dispatches from './pages/Dispatches';
import PartnerWorkspace from './pages/PartnerWorkspace';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authStatus, isLoading } = useStatus();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-mindmeld-primary"></div>
      </div>
    );
  }

  if (!authStatus) {
    return <Navigate to="/signin" replace />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/callback" element={<OAuthCallback />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      <Route path="/enterprise/onboarding" element={<ProtectedRoute><EnterpriseOnboarding /></ProtectedRoute>} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="reports" element={<ExecutiveReports />} />
        <Route path="manager" element={<ManagerDashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="projects" element={<Projects />} />
        <Route path="standards" element={<Standards />} />
        <Route path="corpus" element={<CorpusManagement />} />
        <Route path="documents" element={<DocumentManagement />} />
        <Route path="control-tower" element={<ControlTower />} />
        <Route path="audit" element={<AuditTrail />} />
        <Route path="knowledge" element={<KnowledgeCuration />} />
        <Route path="review" element={<DiscoveryReview />} />
        <Route path="curation" element={<CurationQueue />} />
        <Route path="claims" element={<ClaimsReview />} />
        <Route path="captures" element={<CaptureReview />} />
        <Route path="corrections" element={<CorrectionQueue />} />
        <Route path="dispatches" element={<Dispatches />} />
        <Route path="proposals" element={<PartnerWorkspace />} />
        <Route path="insights" element={<DeveloperInsights />} />
        <Route path="api-tokens" element={<ApiTokens />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
};

export default App;
